import { createRoute, Outlet } from '@tanstack/react-router';
import { layoutRoute } from '@app/router/layout';
import { ReferAndEarnListPage } from '@modules/refer-and-earn/presentation/pages/List';

export const ReferAndEarnLayoutRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/refer-and-earn',
  beforeLoad: () => ({ featureName: 'referAndEarn.module' }),
  component: () => <Outlet />,
});

export const ReferAndEarnListRoute = createRoute({
  getParentRoute: () => ReferAndEarnLayoutRoute,
  path: '/',
  beforeLoad: () => ({ breadcrumb: { key: 'referAndEarn' } }),
  component: () => (
    <ReferAndEarnListPage />
  ),
});
